import styled from 'styled-components'

export const OperatorsContainer = styled.div`
  position: absolute;
  top: 30px;
  margin-left: 3px;
  bottom: 0;
  top: auto;
`

export const OperatorCurrentButton = styled.button`
  background-color: transparent;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-right: 2px solid rgb(171, 190, 209);
  box-shadow: none !important;
`

export const OperatorsList = styled.div`
  position: absolute;
  overflow: hidden;
  left: -3px;
  min-width: 43px;
  box-shadow: rgba(100, 100, 111, 0.3) 0px 7px 29px 0px;
  border-radius: 4px;
  z-index: 2;
`

export const OperatorsListButton = styled.button`
  box-shadow: none !important;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  width: 100%;
  height: 36px;
  color: #303032;

  &:hover {
    background-color: #c7deff;
    color: #303032;
  }

  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`
